/* eslint-disable camelcase */
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import BarChart from '../../../components/Graphs/barchart'
import PieChart from '../../../components/Graphs/piechart'

// export const EventDetailCard = ({ type, evento = {} }) => {
export const Stats = (props) => {
  const {
    nombre_evento,
    vendidos,
    escaneados,
    fecha_funcion,
    id_funcion_fk,
    id_evento_fk,
    hora_inicio,
    ganancia_neta,
    boletos
  } = props
  const xVal = ['Vendidos', 'Escaneados', 'Por Escanear']
  const yVal = [vendidos, escaneados, vendidos - escaneados]
  const yValues = []
  const xValues = []
  for (let i = 0; i < 3; i++) {
    if (yVal[i] > 0) {
      yValues.push(yVal[i])
      xValues.push(xVal[i])
    }
  }
  const [userData, setUserData] = useState({
    labels: xValues,
    datasets: [
      {
        label: 'Boletos',
        data: yValues,
        backgroundColor: [
          'rgba(17,100,192,23)',
          '#900796',
          '#ffffff',
          '#f3ba2f',
          '#2a71d0'
        ],
        borderColor: 'black',
        borderWidth: 1
      }
    ]
  })
  const [plot, SetPlotOptions] = useState({
    legend: {
      labels: {
        fontColor: 'White',
        fontSize: 18
      }
    },
    scales: {
      yAxes: [{
        ticks: {
          fontColor: 'White',
          fontSize: 18,
          stepSize: 1,
          beginAtZero: true
        }
      }],
      xAxes: [{
        ticks: {
          fontColor: 'White',
          fontSize: 14,
          stepSize: 1,
          beginAtZero: true
        }
      }]
    }
  })

  return (
    <div>
    <div className="d-sm-flex align-items-center justify-content-between pt-xl-1 mb-3 pb-3">
            <h1 className="h2 mb-sm-0 text-primary">Estadísticas</h1>
            <div className="dropdown">
            <button className="btn btn-secondary dropdown-toggle h2 mb-sm-0 text-primary" type="button" data-bs-toggle="dropdown" aria-expanded="false">
            Más estadísticas
            </button>
            <ul className="dropdown-menu">
              <li><Link to= {`/mi-cuenta/estadisticas/total/${id_evento_fk}`} className="dropdown-item" >Estadísticas generales</Link></li>
            </ul>
            </div>
          </div>
    <h5 className="card-title d-flex align-items-center fw-bold text-decoration-none mt-3 mb-4 ">Función {fecha_funcion} :</h5>
    <BarChart chartData={userData} plotOptions={plot}/>
    {/* <PieChart chartData={userData} /> */}
    <div className="card border-card card-event-dashboard bg-black text-light">
        {/* <div className="img-wrapper zoom">
          <img src={evento.foto_portada} className="card-img-top" alt={evento.nombre} />
        </div> */}
        <div className="card-body card-event-body">
          <h5
            className="card-title text-light mb-0">{nombre_evento}
          </h5>
          <div className="card-event-data">
            {/* <p className="d-flex align-items-center fw-bold text-decoration-none mt-1 mb-n2">{evento.fecha}</p>
            <p
              className="d-flex
              align-items-center fw-bold text-decoration-none mt-1 mb-n2"
             >
              {evento.ubicacion}
            </p>
            <p
              className="d-flex
              align-items-center fw-bold text-decoration-none mt-1 mb-n2"
             >
              Precio: {evento.precio} MXN
            </p> */}
            {/* <h6
              className="card-title d-flex
              align-items-center fw-bold text-decoration-none mt-2 mb-n1"
             >
              Funciones
            </h6>
            <div className='d-flex
               fw-bold text-decoration-none mt-1 mb-n2 justify-content:space-between'>
            {evento.funciones.map((funcion, index) => (
              <div key={index} className="me-2">
                <div>{`Fecha función: ${funcion.fecha_funcion}`}</div>
                <div>{`Hora inicio: ${funcion.hora_inicio}`}</div>
                <div>{`Hora fin: ${funcion.hora_fin}`}</div>
              </div>
            ))}
            </div> */}
            {/* <h6
              className="card-title d-flex
              align-items-center fw-bold text-decoration-none mt-2 mb-n1"
             >
              Estadísticas
            </h6> */}
            <div className=''>
            <p className="d-flex align-items-center fw-bold text-decoration-none mt-1 mb-n2">Ingresos: {ganancia_neta} MXN</p>
                <p className="d-flex align-items-center fw-bold text-decoration-none mt-2 mb-n2">Boletos vendidos: {vendidos}</p>
                {boletos.map((boleto, index) => (
                  <p key={index} className="d-flex align-items-center fw-bold text-decoration-none mt-2 mb-n2">Boletos {boleto[0]} vendidos: {boleto[1]}</p>
                ))}
                <p className="d-flex align-items-center fw-bold text-decoration-none mt-2 mb-n2">Fecha show: {fecha_funcion} </p>
                <p className="d-flex align-items-center fw-bold text-decoration-none mt-2 mb-n2">Hora show: {hora_inicio}</p>
                <p className="d-flex align-items-center fw-bold text-decoration-none mt-2 mb-n2">id de la funcion: {id_funcion_fk} {id_evento_fk} </p>
                <h6 className="card-title d-flex align-items-center fw-bold text-decoration-none mt-3 mb-n1">Restantes</h6>
                {boletos.map((boleto, index) => (
                  <p key={index} className="d-flex align-items-center fw-bold text-decoration-none mt-2 mb-n2">Boletos {boleto[0]} restantes: {boleto[2]}</p>
                ))}
            </div>
          </div>
        </div>
      </div>
      </div>
  )
}
